module.exports = __webpack_public_path__ + "img/no.65cb9cc6.png";